import Gallery from '../new-event-layouts/shared/gallery';
import PaymentStatusModal from 'widget/event_components/Ticket/components/PaymentStatusModal';

export const MODALS = {
  galleryModal: {
    title: 'Gallery',
    Component: Gallery,
  },
  checkoutModal: {
    title: '',
    Component: PaymentStatusModal,
  },
};
